import { LinearProgress, FormHelperText, FormControl, Link, Grid, SelectProps, InputLabel, Select, MenuItem, TextField, SelectChangeEvent, Dialog, DialogContent, DialogTitle, DialogActions,IconButton } from "@mui/material";
import { DataGridPro, GridColDef, GridFooterContainer, GridPagination } from "@mui/x-data-grid-pro";
import { Formik, Form } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import useAuth from "../../context/AuthProvider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import "react-datepicker/dist/react-datepicker.css";
import { FMTextField } from "../Elements/input";
import CircularProgress from '@mui/material/CircularProgress';
import { FileRejection, useDropzone } from 'react-dropzone';
import Tooltip from '@mui/material/Tooltip';
import Swal from "sweetalert2";
import { CustomerPolicyDocument, CustomerPolicyTaxAndFees, UploadedDocumentType } from "../../models/TaxTransactionReportModel";
import { CustomerPolicyDetailsModel } from "../../models/CustomerPolicyDetailsModel";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import * as Yup from 'yup';
import { compactString } from "../../helper/utils";
import { isValid } from "../Elements/PolicyStatuses";
import { isDateGreaterThanToday } from "./CustomFunctions";
import { apiClient } from "../../helper/api";
import useAppDialog from "../../hooks/useAppDialog";
import { DialogResponse, DialogResult } from "../Dialog/dialogTypes";
import { Box } from "@mui/system";
import { AppFlags } from "../../helper/config";
import { AppRoutes } from "../../helper/appRoutes";

export interface LObList {
    id: number;
    businessCode: string;
    coverageName: string;
    stateId: number;
}

export interface ReqDocuments {
    documentName?: string,
    documentTypeId?: number
    isRequired?: boolean
}

export const AddEditCustomerPolicyDetails = () => {
    const [loading, setloading] = useState(true);
    const { user } = useAuth();
    const token = user?.token;
    const params = useParams();
    const navigate = useNavigate();
    const isFileMuleUser = user?.userRoles.split(",").includes("Super Admin")

    const initCustomerPolicyDetails: CustomerPolicyDetailsModel = {}
    const [IsSingleDocument, setIsSingleDocument] = useState(true);
    const [CustomerPolicyDetails, setCustomerPolicyDetails] = useState(initCustomerPolicyDetails)
    const [selectedTransaction, setselectedTransaction] = useState<string>('')
    const [selectedLOB, setSelectedLOB] = useState<string>('')
    const [partnerId, setPartnerId] = useState<string>("")
    const [PolicyDocument, setPolicyDocument] = React.useState<CustomerPolicyDocument[]>([]);
    const [UploadedDocument, setUploadedDocument] = React.useState<UploadedDocumentType[]>([]);
    const [revertedDocument, setRevertedDocument] = React.useState<UploadedDocumentType[]>([]);
    const [CustTaxAndFees, setCustTaxAndFees] = useState<CustomerPolicyTaxAndFees[]>([]);
    const [taxAndFeeOptions, setTaxAndFeeOptions] = useState([]);
    const [policyNumber, setPolicyNumber] = useState<string>("");
    const [binderFiledDate, setBinderFiledDate] = useState<string>("");
    const [revertDocument, setRevertDocument] = useState<{ documentTypeId: number; customerPolicyDocumentId: number; isRevert: boolean}[]>([]);
    const [selectedStateOption, setSelectedStateOption] = useState<any>(1);
    const initialStates = { stateId: 0, stateName: "" };
    const [data, setData] = useState<any>(null);
    const [States, setStates] = useState([initialStates]);
    const [showDoc, setShowDoc] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    const Reqdocuments: ReqDocuments = {
        documentName: "",
        documentTypeId: 0,
        isRequired: false,
    }
  
    const [RequireedDocuments, setRequiredDocuments] = useState([Reqdocuments]);

    let initTaxAndFee: CustomerPolicyTaxAndFees = {
        customerPolicyId: 0,
        amount: "",
        payee: "",
        taxName: "",
        paymentPeriod: ""
    }

    const goBack = () => {
        navigate(AppRoutes.root);
    }
    const getDocTypeName = (docTypeId: number) => {
        const doc = RequireedDocuments.find((d) => d.documentTypeId === docTypeId);
        return doc ? doc.documentName : "";
    }

    // Helper function to display MISC user names as "miscstaff" for client users
    const getDisplayName = (uploadedBy: string, uploadedByRoleId?: number) => {
        if (!user?.userRoles) return uploadedBy || '-';
        
        const roles = user.userRoles.split(",");
        const isClientUser = roles.some(role => 
            ['Customer User', 'Client Admin', 'Client Accounting', 'Client Operations', 'Client Processors'].includes(role.trim())
        );
        
        if (isClientUser) {
            const clientRoleIds = [1, 6, 8, 9, 10, 11];
            return clientRoleIds.includes(uploadedByRoleId || 0) ? uploadedBy || '-' : 'miscstaff';
        } else {
            return uploadedBy || '-';
        }
    }
    const fetchData = () => {
        setloading(true);
        setSelectedLOB('');
        setInsuranceId('');
        apiClient(`/PolicyDashBoard/getCustomerPolicyDetails?customerPolicyId=${params.CustomerPolicyId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res) return

                if (res.data != null) {
                    var data = res.data;
                    setData(data)

                    data.policyFilingDueDate = data.policyFilingDueDate !== null && data.policyFilingDueDate !== undefined ? moment(data.policyFilingDueDate).format("MM/DD/YYYY") : data.policyFilingDueDate;
                    setBinderFiledDate(data.filedBinderDate??'');

                    data.dateFiled = data.dateFiled !== null && undefined && "" ? moment(data.dateFiled).format("MM/DD/YYYY") : data.dateFiled;
                    setInsuranceId(data.insuranceCompanyId);
                    setCustomerPolicyDetails(data);
                    setSelectedStateOption(data.stateId);
                    setselectedTransaction(data.transactionId);
                    setPolicyNumber(data.policyNumber);
                    setPartnerId(data.partnersId);
                    setSelectedLOB(data.lobId != null ? String(data.lobId) : '');
                    handleStateChange(data.stateId);

                    setPolicyStatus(data.status);

                }
            }).finally(() => {
                setloading(false);
            });
    }

    const groupedRows = useMemo(() => {
        console.log('groupedRows useMemo running with:', { 
            UploadedDocumentLength: UploadedDocument?.length, 
            RevertedDocumentLength: revertedDocument?.length,
            refreshKey 
        });
        
        const groups = new Map<string, UploadedDocumentType[]>();
        if (UploadedDocument && Array.isArray(UploadedDocument)) {
            UploadedDocument.forEach((doc) => {
                const fileName = Array.isArray((doc as any).documentName) ? ((doc as any).documentName?.[0] || '') : (doc as any).documentName;
                const key = `${doc.blob_Address}::${fileName}`;
                const arr = groups.get(key) || [];
                arr.push(doc);
                groups.set(key, arr);
            });
        }
        const revertGroups = new Map<string, UploadedDocumentType[]>();
        if (revertedDocument && Array.isArray(revertedDocument)) {
            revertedDocument.forEach((doc) => {
                const fileName = Array.isArray((doc as any).documentName) ? ((doc as any).documentName?.[0] || '') : (doc as any).documentName;
                const key = `${doc.blob_Address}::${fileName}`;
                const arr = revertGroups.get(key) || [];
                arr.push(doc);
                revertGroups.set(key, arr);
            });
        }

        const mappedRows = Array.from(groups.values()).map((docs) => {
            const first = docs[0] as any;
            const fileName = Array.isArray(first.documentName) ? (first.documentName?.[0] || '') : first.documentName;
            const docTypeNames = Array.from(new Set(
                docs.map((d) => getDocTypeName(d.documentTypeId) || (d as any).name).filter(Boolean)
            )).join(', ');
            const uploadedAt = first.dateUploadedAt ? moment.utc(first.dateUploadedAt).local().format('MM/DD/YYYY HH:mm') : '-';
            // Use the uploadedByFullName field from the API response, fallback to current user if not available
            const uploadedBy = getDisplayName(first.uploadedByFullName || '-', first.uploadedByRoleId);
            // Use the fileSizeKB field from the API response (it's already in KB)
            const sizeText = typeof first.fileSizeKB === 'number' ? `${first.fileSizeKB} KB` : '-';
            const pagesText = typeof first.numberOfPages === 'number' ? first.numberOfPages : '-';
            return { 
                first, 
                fileName, 
                docTypeNames, 
                uploadedAt, 
                uploadedBy, 
                sizeText, 
                pagesText,
                allDocuments: docs, // Store all documents for deletion
                // Add raw date for sorting
                rawUploadDate: first.dateUploadedAt ? new Date(first.dateUploadedAt) : new Date(0),
                isReverted: false
            };
        }).sort((a, b) => b.rawUploadDate.getTime() - a.rawUploadDate.getTime());
        
        const revertedRows = Array.from(revertGroups.values()).map((docs, idx) => {
            const first = docs[0] as any;
            const fileName = Array.isArray(first.documentName) ? (first.documentName?.[0] || '') : first.documentName;
            const docTypeNames = Array.from(new Set(
                docs.map((d) => getDocTypeName(d.documentTypeId) || (d as any).name).filter(Boolean)
            )).join(', ');
            const uploadedAt = first.dateUploadedAt ? moment.utc(first.dateUploadedAt).local().format('MM/DD/YYYY HH:mm') : '-';
            // Use the uploadedByFullName field from the API response, fallback to current user if not available
            const uploadedBy = getDisplayName(first.uploadedByFullName || first.uploadedBy || '-', first.uploadedByRoleId);
            // Use the fileSizeKB field from the API response (it's already in KB)
            const sizeText = typeof first.fileSizeKB === 'number' ? `${first.fileSizeKB} KB` : '-';
            const pagesText = typeof first.numberOfPages === 'number' ? first.numberOfPages : '-';
            
            return { 
                first, 
                fileName, 
                docTypeNames, 
                allDocuments: docs, // Store all documents for deletion
                uploadedAt, 
                uploadedBy, 
                sizeText, 
                pagesText,
                isReverted: true,
                rawUploadDate: first.dateUploadedAt ? new Date(first.dateUploadedAt) : new Date(0)
            };
        });

        // Combine all documents and sort by upload date (latest first)
        const allRows = [...mappedRows, ...revertedRows];
        const result = allRows.sort((a, b) => b.rawUploadDate.getTime() - a.rawUploadDate.getTime());
        return result;
    }, [UploadedDocument, revertedDocument, RequireedDocuments, user, refreshKey]);
    const getPolicyDocuments = () => {
        apiClient(`/DiligentSearch/getDiligentSearchDocument?customerPolicyId=${params.CustomerPolicyId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res) return
                setPolicyDocument(res.data);
            })
    }

    const getUploadedDocuments = () => {
        const timestamp = new Date().getTime();
        return apiClient(`/customer/getUploadedDocuments?customerPolicyId=${params.CustomerPolicyId}&_t=${timestamp}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res || !res.data || !Array.isArray(res.data)) {
                    console.log('Setting UploadedDocument to empty array');
                    setUploadedDocument([]);
                    return;
                }
                var policyDoc = res.data.filter((item: UploadedDocumentType) => item.documentTypeId === 0);
                setPolicyDocument(policyDoc);
                setUploadedDocument(res.data);
            }).catch((error) => {
                setUploadedDocument([]);
            })
    }

    const getRevertedDocuments = () => {
        const timestamp = new Date().getTime();
        return apiClient(`/customer/getRevertedDocuments?customerPolicyId=${params.CustomerPolicyId}&_t=${timestamp}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res || !res.data || !Array.isArray(res.data)) {
                    setRevertedDocument([]);
                    return;
                }
                setRevertedDocument(res.data);
            }).catch((error) => {
                setRevertedDocument([]);
            })
    }
    async function getTaxPayeeByTaxType(customerpolicyid: number, taxName: string) {
        const res: CustomerPolicyTaxAndFees = await apiClient(`/TaxesAndFees/GetTaxandFeePayeeByCustTaxFeesId?customerPolicyId=${customerpolicyid}&taxName=${taxName}`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        });

        return res;
    }
    const fetchCustomerPolicyTaxAndFees = () => {
        apiClient(`/CustomerPolicyTaxesAndFees/getByCustomerPolicyId?customerPolicyId=${params.CustomerPolicyId}`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        }).then((res) => {
            if (!res) return
            setCustTaxAndFees(res.data);
        })
    }
    const fetchTaxAndFeesOptions = () => {
        apiClient(`/TaxesAndFees/GetTaxandFeeNameByStateId?customerPolicyId=${params.CustomerPolicyId}`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        }).then((responseJson) => {
            if (!responseJson) return
            setTaxAndFeeOptions(responseJson.data);
        })
    }

    useEffect(() => {
        fetchStates();
        fetchData();
        getTransactionType();
        fetchTransactionTypesData();
        fetchCustomerPolicyTaxAndFees();
        fetchTaxAndFeeData();
        fetchTaxAndFeesOptions();
        getPolicyDocuments();
        getUploadedDocuments();
        getRevertedDocuments();
    }, [])


    const initialInsuranceCompany = { insuranceCompanyId: 0, insuranceCompanyName: "" };
    const [carriers, setCarriers] = useState([initialInsuranceCompany]);
    const initialLOB = { id: 0, businessCode: "" };
    const [LOB, setLOB] = useState([initialLOB]);
    const initialPartners = { partnersId: 0, customerName: "" };
    const [getPartners, setPartners] = useState([initialPartners]);
    const getTransactionType = () => {
        apiClient('/Partners/getPartners',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((responseJson) => {
                if (responseJson?.data == null) return
                setPartners(responseJson.data)
            })
    }
    interface transactiontypemodel {
        transactionId: number, transactionTypeName: string
    }
    const fetchTransactionTypesData = () => {
        apiClient("/CustomerPolicy/GetTransactionTypeList", {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        }).then((responseJson) => {
            if (!responseJson) return
            // Do something with the response

            const translist: transactiontypemodel[] = responseJson.data.filter((item: transactiontypemodel) => item.transactionTypeName.toLowerCase() !== 'all')
            setTransactionType(translist);
        })
    };

    interface propsDoc {
        open: boolean
        handleDocClose: () => void,
        customerPolicyId: any,
        PolicyDocument: CustomerPolicyDocument[] | undefined
    }
    const handleDocClose = () => {

        setShowDoc(false)
        fetchData();
    };

    const isAdmin = user?.userRoles.split(",").includes("Super Admin")
    const mISCFiler = user?.userRoles.split(",").includes("MISC Filer")
    const MISCStateReporter = user?.userRoles.split(",").includes("MISC State Reporter")
    // Helper function to determine if user can delete documents (admin or client users)
    const canDeleteDocuments = () => {
        if (!user?.userRoles) return false;
        const roles = user.userRoles.split(",");
        return roles.some(role => 
            ['Super Admin', 'Client Admin', 'Customer User', 'Client Accounting', 'Client Operations', 'Client Processors'].includes(role.trim())
        );
    };

    const isPolicyTBD = compactString(policyNumber) === compactString("TBD") || compactString(policyNumber) === compactString("TBA")
    const isPolicyNumberDisabled = !(isAdmin || isPolicyTBD)

    const [TransactionType, setTransactionType] = useState<transactiontypemodel[]>();
    const ShowAllDocument: React.FC<propsDoc> = ({ open, handleDocClose, customerPolicyId, PolicyDocument }) => {

        const { user } = useAuth();
        const token = user?.token;

        useEffect(() => {

        }, [])
        return (

            <Dialog open={open} onClose={handleDocClose} fullWidth maxWidth={'md'}>
                {loading && <LinearProgress style={{ margin: 2 }} />}
                <div > <DialogTitle className='card-title'>All Document</DialogTitle></div>
                <div className="">
                    <React.Fragment>
                        <DialogContent>
                            {PolicyDocument && PolicyDocument?.length > 0 ?
                                <table className="table">
                                    <tbody>

                                        {PolicyDocument?.map((value, key) =>
                                            <Grid gridRow={2} container spacing={2} key={key}>
                                                <tr key={key}>
                                                    <td>
                                                        <div style={{ maxWidth: '920px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                            <Grid>

                                                                <Link href={value.blob_Address} sx={{ textDecoration: "none " }} target="_blank">
                                                                    <span style={{ marginRight: "8px" }}>{value.documentName.split("_").slice(1).join("_")}</span>
                                                                    <svg width="20" height="20" viewBox="0 0 22 22" fill="none" className="" xmlns="http://www.w3.org/2000/svg" ><path d="M19.25 13.75V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V13.75M6.41667 9.16667L11 13.75M11 13.75L15.5833 9.16667M11 13.75V2.75" stroke="#02A4E3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path></svg>

                                                                </Link>
                                                            </Grid>

                                                        </div>
                                                    </td>
                                                </tr>
                                            </Grid>
                                        )}
                                    </tbody>
                                </table>
                                : <span>No supportive document found for this transaction.</span>}

                        </DialogContent>
                        <DialogActions>
                            <button className=" btn-2 btn d-flex btn-primary search-btn  " type="button" onClick={handleDocClose}  >Cancel</button>

                        </DialogActions>
                    </React.Fragment>
                </div>
            </Dialog>
        );
    }
     const handleRemoveUploadedDoc = async (rowData: any) => {

        const resDlg = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })

        if (!resDlg.isConfirmed) {
            return;
        }

        setloading(true);
        try {
            // Check if this is a grouped document row or single document
            let documentsToDelete: UploadedDocumentType[] = [];
            
            if (rowData.allDocuments && Array.isArray(rowData.allDocuments)) {
                // This is a grouped document row
                documentsToDelete = rowData.allDocuments;
            } else if (rowData.customerPolicyDocumentId) {
                // This is a single document
                documentsToDelete = [rowData];
            } else {
                throw new Error('Invalid document data structure');
            }

            // Delete all documents
            const deletePromises = documentsToDelete.map((doc: UploadedDocumentType) => 
                apiClient(`/customer/DeleteUploadedDocument?customerPolicyDocumentId=${doc.customerPolicyDocumentId}`, {
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    }),
                    method: "Delete",
                })
            );
            
            await Promise.all(deletePromises);
            await Promise.all([
                getUploadedDocuments(),
                getRevertedDocuments(),
                fetchRequiredDocumentName()
            ]);
            await new Promise(resolve => setTimeout(resolve, 100));
            setRefreshKey(prev => prev + 1);

            const successMessage = documentsToDelete.length > 1 
                ? `All ${documentsToDelete.length} documents have been successfully deleted.`
                : 'The document has been successfully deleted.';

            Swal.fire({
                icon: 'success',
                title: 'Deleted Successfully!',
                text: successMessage,
                confirmButtonText: 'OK'
            });
        }
        catch (error) {
            console.error('Delete error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Delete Failed',
                text: 'Some documents could not be deleted. Please try again.',
                confirmButtonText: 'OK'
            });
        } finally {
            setloading(false);
        }
    }

    const fetchStates = () => {

        apiClient('/FilingsByUser/getUserFilingStates',
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((responseJson) => {
                if (!responseJson) return
                setStates(responseJson.data)
            })
    }

    const handleStateChange = (event: number) => {

        apiClient(`/InsuranceCompany/getPartnerInsuranceCompanyByState?stateId=${event}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((responseJson) => {
                if (!responseJson) return

                setCarriers(responseJson.data)
                getLineOfbusiness(event);

            }).finally(() => {
                setloading(false);
            });
    };
    const getLineOfbusiness = (stateId: number | undefined) => {
        apiClient(`/LineOfBusiness/getLineOBusinessByStateId?stateId=${stateId}`,
            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((responseJson) => {
                if (!responseJson) return
                setLOB(responseJson.data)

            }).finally(() => {
                setloading(false);
            });
    }

    const [insuranceId, setInsuranceId] = useState<string>('');
    const baseStyle = {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        padding: '10px',
        borderWidth: 1,
        borderRadius: 8,
        borderColor: '#41729F',
        borderStyle: 'dashed',
        cursor: 'pointer',


        backgroundColor: '#fafafa',
        color: '#41729F',
        outline: 'none',
        transition: 'border .24s ease-in-out'
    };

    const focusedStyle = {
        borderColor: '#2196f3'
    };

    const acceptStyle = {
        borderColor: '#00e676'
    };

    const rejectStyle = {
        borderColor: '#ff1744'
    };
    var formData = new FormData();
    interface CustomProps {
        onChange: (event: { target: { name: string; value: string } }) => void;
        name: string;
    }

    const NumericFormatCustom = React.forwardRef<NumericFormatProps, CustomProps>(
        function NumericFormatCustom(props, ref) {
            const { onChange, ...other } = props;

            return (
                <NumericFormat
                    {...other}
                    getInputRef={ref}
                    onValueChange={(values) => {
                        onChange({
                            target: {
                                name: props.name,
                                value: values.value,
                            },
                        });
                    }}
                    thousandSeparator
                    valueIsNumericString
                    prefix="$"
                />
            );
        },
    );



    function GenericStyledDropZone(props: any & ReqDocuments) {
        const maxLength = 20;
        const { limitSize = 10 } = props

        const onDropRejected = (fileRejections: FileRejection[]) => {
            const first = fileRejections?.[0]
            const errCodes = first?.errors?.map((e) => e.code) || []

            if (errCodes.includes('file-too-large')) {
                Swal.fire({
                    icon: 'error',
                    title: 'File too large',
                    text: `Maximum file size ${limitSize}MB.`,
                    confirmButtonText: 'OK'
                })
                return
            }
            if (errCodes.includes("file-invalid-type")) {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid file type',
                    text: `Only .pdf, Word, and image files are allowed.`,
                    confirmButtonText: 'OK'
                })
                return
            }
            Swal.fire({
                icon: 'error',
                title: 'Upload failed',
                text: `Please check your file and try again.`,
                confirmButtonText: 'OK'
            })
        }

        const {
            getRootProps,
            getInputProps,
            acceptedFiles,
            isFocused,
            isDragAccept,
            isDragReject,
        } = useDropzone({
            maxFiles: 10,
            maxSize: limitSize * 1024 * 1024,
            accept: { 'application/pdf': ['.pdf'], 'image/*': [], 'application/msg': ['.msg'] },
            onDrop: (files) => {
                const file = files?.[0]
                if (!file) return

                const regex = new RegExp(`^${props?.doc?.documentTypeId}__.+$`)
                formData.forEach((value, key) => {
                    if (regex.test(key)) {
                        formData.delete(key); // Delete keys matching srdmId pattern
                    }
                });
                files.map((file) => {
                    formData.append(props?.doc?.documentTypeId + "__" + file.name, file);
                });
            },
            onDropRejected,
        });

        const style = useMemo(() => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {})
        }), [
            isFocused,
            isDragAccept,
            isDragReject
        ]);

        const files = acceptedFiles.map(file => (
            <React.Fragment >
                <span style={{ fontSize: "14px" }}>
                    {file?.name?.length > 35 ? file?.name?.substring(0, 35) + '...' : file?.name}
                </span>
                <br />
            </React.Fragment>
        ));

        return (
            <React.Fragment>
                <div className=" box-style col-lg-12">
                    <div {...getRootProps({ style })}>
                        <input {...getInputProps()} name={props?.doc?.documentName} />
                        <p style={{ fontSize: "16px", color: "#162E3C", fontWeight: "600" }}>Upload  {props?.doc?.documentName === '' || props?.doc?.documentName === null || props?.doc?.documentName === undefined ? " documents for storage" : props?.doc?.documentName}
                            <span style={{ color: "red" }}>{props?.doc?.isRequired ? "*" : ""}</span></p>
                    </div>
                    <span >
                        <p style={{ height: "20px", textAlign: "start", margin: 2 }}>{files}</p>
                    </span>
                </div>
            </React.Fragment>
        );
    }

    const { openDialog_Message } = useAppDialog()
    const handleSendMessage = async (CustomerPolicyId: number, status: string) => {
        try {
            setloading(true);
            openDialog_Message({
                custPolId: String(CustomerPolicyId)
            }).then((res: DialogResponse) => {
                if (res.dialogResult === DialogResult.OK) {

                }
                return res
            })
            setloading(false);
        } catch (error) {
            setloading(false);
        }
    };
    function RevertDocument(
        documentTypeId: number,
        documentName: string | undefined,
        customerPolicyDocumentId: number
    ) {
        const isRevertExist = revertDocument.some((val) => val.documentTypeId === documentTypeId);
        if (!isRevertExist || true) {
            setRevertDocument((prev) => [...prev,  { documentTypeId, customerPolicyDocumentId, isRevert: true},]);
        } else {
            setRevertDocument((prev) =>
                prev.filter((val) => val.documentTypeId !== documentTypeId || val.customerPolicyDocumentId !== customerPolicyDocumentId)
            );
        }
    }

    const handleRevert = (documentDetails: any, isAll: boolean) => {
        Swal.fire({
            title:'Send Back to Client',
            text: `Are you sure you want to Send Back to Client ?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#007BFF',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Confirm',
            cancelButtonText: 'Cancel',
            padding: '20px',
            backdrop: true,
            customClass: {
                popup: 'custom-swal-popup',
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
            },
            width: '500px',
        })
        .then((result) => {
            if (result.isConfirmed) {
                documentDetails.forEach((doc:any) => {
                    RevertDocument(doc.documentTypeId, doc.documentName, doc.customerPolicyDocumentId);
                });
                handleSendMessage(Number(params.CustomerPolicyId), getPolicyStatus || "")
            }
        })
    };

    function ViewDocuments(props: { docTypeId: number | undefined }) {
        const value = UploadedDocument.find((item) => item.documentTypeId === props.docTypeId);
        const isRevertExist = revertDocument.some((val) => val.documentTypeId === value?.documentTypeId);
        return (
            <>
                {value ? (
                    <div className="box-style col-lg-12">
                        <Tooltip title={`Download ${value.documentName.split("_").slice(1).join("_")}`} arrow>
                            <Link
                                href={value.blob_Address}
                                sx={{ textDecoration: "none", display: "flex", alignItems: "center" }}
                                target="_blank"
                            >
                                <div
                                    role="presentation"
                                    tabIndex={0}
                                    style={{
                                        flex: "1 1 0%",
                                        display: "flex",
                                        alignItems: "center",
                                        padding: "10px",
                                        borderWidth: "1px",
                                        borderRadius: "8px",
                                        borderColor: "rgb(65, 114, 159)",
                                        borderStyle: "dashed",
                                        backgroundColor: "rgb(250, 250, 250)",
                                        color: "rgb(65, 114, 159)",
                                        outline: "none",
                                        transition: "border 0.24s ease-in-out",
                                    }}
                                >
                                    <span style={{ marginRight: "8px" }}>
                                        <p>{value.name}</p>
                                    </span>
                                    <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 22 22"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M19.25 13.75V17.4167C19.25 17.9029 19.0568 18.3692 18.713 18.713C18.3692 19.0568 17.9029 19.25 17.4167 19.25H4.58333C4.0971 19.25 3.63079 19.0568 3.28697 18.713C2.94315 18.3692 2.75 17.9029 2.75 17.4167V13.75M6.41667 9.16667L11 13.75M11 13.75L15.5833 9.16667M11 13.75V2.75"
                                            stroke="#02A4E3"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        ></path>
                                    </svg>
                                </div>
                            </Link>
                        </Tooltip>
                        <p
                            style={{
                                flex: 1, 
                                height: "auto", 
                                wordBreak: "break-word", 
                                textAlign: "start",
                                margin: "2px",
                                color: "#555",
                            }}
                        >
                            {value.documentName.split("_").slice(1).join("_")}
                        </p>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                            <IconButton 
                                color="error" 
                                onClick={() => handleRemoveUploadedDoc(value)}
                                size="small"
                                title="Delete Document"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#162E3C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </IconButton>
                            {AppFlags  && data?.isClient ? 
                                <button
                                    className={`${ isRevertExist ? 'active-btn-red' : 'active-btn-blue'} me-2`}
                                    type="button"
                                    onClick={() => handleRevert([value], false)}
                                    disabled={isRevertExist}
                                >
                                    Revert
                                </button>
                            : null}
                        </div>
                    </div>
                ) : null}
            </>
        );
    }
    
    const handlePatnerChange = (event: SelectChangeEvent) => {
        setPartnerId(event.target.value);
    };

    const handleStateOptionChange = (event: SelectChangeEvent) => {
        setSelectedLOB('');
        setInsuranceId('')
        setSelectedStateOption(event.target.value);
        handleStateChange(Number(event.target.value));
    };
    const handleInsuranceChange = (event: SelectChangeEvent) => {

        setInsuranceId(event.target.value);
    };
    const handleTransactionChange = (event: SelectChangeEvent) => {

        setselectedTransaction(event.target.value);
    };
    const handleLOBChange = (event: SelectChangeEvent) => {
        setSelectedLOB(event.target.value ?? '');
    };

    const [getPolicyStatus, setPolicyStatus] = React.useState<string>('');
    const policyStatus = [
        'Missing Documents', 'Pending Documents', 'Flagged', 'Ready to File', 'Pending Autofile', 'Pending state review', 'State Flagged', 'Filed', 'IsClosed', 'Not Started'
    ]

    const handlePolicyStatus = (event: SelectChangeEvent) => {
        setPolicyStatus(event.target.value);
    };
    interface TaxandFee {

        taxTypeId: number;
        taxName: string;
    }

    let initlistTaxandFee: TaxandFee = {
        taxTypeId: 0,
        taxName: ""
    }


    const [TaxandFees, setTaxandFees] = useState<TaxandFee[]>([initlistTaxandFee]);
    const fetchTaxAndFeeData = () => {
        apiClient(`/TaxesAndFees/GetTaxandFeeNameandIdByStateId?customerPolicyId=${params.CustomerPolicyId}`, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            }),
        })
            .then((responseJson) => {
                if (responseJson?.data == null) return
                setTaxandFees(responseJson.data);
            })
    };

    const handleDeleteRow = (index: number) => {
        const updatedArray = CustTaxAndFees.filter((_, idx) => idx !== index);
        setCustTaxAndFees(updatedArray);

    };
    const handleTaxNameChange = async (e: any, index: any) => {
        const newArr = [...CustTaxAndFees];
        newArr[index].taxName = e.target.value;
        const res = await getTaxPayeeByTaxType(CustomerPolicyDetails?.customerPolicyId ?? 0, e.target.value);
        if (!res) return

        newArr[index].payee = res?.payee ?? "";
        var payee = (document?.getElementById("payee" + index) as HTMLInputElement) ?? ""
        var amount = (document?.getElementById("amount" + index) as HTMLInputElement) ?? ""
        var paymentPeriod = (document?.getElementById("paymentPeriod" + index) as HTMLInputElement) ?? ""


        newArr[index].amount = res?.amount ?? "";
        amount.value = newArr[index].amount ?? "";
        newArr[index].paymentPeriod = res?.paymentPeriod ?? "";
        setCustTaxAndFees(newArr);

        payee.value = res?.payee ?? "";

        paymentPeriod.value = res?.paymentPeriod ?? "";

    };

    function fetchRequiredDocumentName() {
        setloading(true);
        return apiClient(`/customer/getRequiredDocuments?customerPolicyId=${params.CustomerPolicyId}&all=1`,
            {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res) return
                setRequiredDocuments(res.data);

            }).finally(() => {
                setloading(false);
            });
    }

    const CheckIsSingleDocument = () => {
        setloading(true);
        apiClient(`/MasterPolicyType/checkIsSingleDocument?custPolicyId=${params.CustomerPolicyId}`,
            {
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            }).then((res) => {
                if (!res) return

                setIsSingleDocument(res.data);

                if (!res.data) {
                    fetchRequiredDocumentName();
                } else {
                    setRequiredDocuments([{ documentName: "Other", documentTypeId: 73 }]);
                }

            }).finally(() => {
                setloading(false);
            });
    }

    useEffect(() => {
        if (!params.CustomerPolicyId) return

        CheckIsSingleDocument();
    }, [params]);

    const updateDocuments = (data: any, setSubmitting: any) => {
        let count = 0
        formData.forEach(element => {
            count = count + 1;
        });
        if (count < 1) {
            alert("select a document");
            setSubmitting(false);
            setloading(false);

            return;

        } else {
            setloading(true);
            formData.append('transactionTypeId', data.transactionTypeId.toString() ?? "");
            let ID = params.customerPolicyId?.toString() ?? "";
            formData.append('CustomerPolicyId', ID);

            if (IsSingleDocument) {
                apiClient(`/CustomerPolicy/CorrectedDocumentSubmission/`,
                    {
                        method: 'POST',
                        headers: new Headers({
                            // 'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        }),
                        body: formData  // <-- Post parameters

                    }).then((res) => {
                        if (!res) return
                        if (res.resp == 200) {
                        } else {
                            alert(res.data);
                        }
                    }).finally(() => {
                        setSubmitting(false);
                        formData = new FormData();
                        setloading(false);
                    });

            } else {
                apiClient(`/CustomerPolicy/CorrectedDocumentSubmission/`,
                    {
                        method: 'POST',
                        headers: new Headers({
                            // 'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        }),
                        body: formData  // <-- Post parameters

                    })
                    .then((res) => {
                        if (!res) return
                        if (res.resp == 200) {
                        } else {
                            alert(res.data);
                        }
                    }).finally(() => {
                        setSubmitting(false);
                        formData = new FormData();
                        setloading(false);
                    });
            }
        }
    }

    const handlDeletePolicy = () => {
        setloading(true);
        Swal.fire({
            title: 'Are you sure, you want to delete this filing?',
            text: "You won't be able to revert this!",
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/CustomerPolicy/DeleteCustomerPolicy?id=" + `${params.CustomerPolicyId}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    ).then((res) => {
                        if (!res) return
                        if (res.status) {
                            Swal.fire(
                                'Deleted!',
                                'Transaction has been deleted.',
                                'success')
                                .then(() => {
                                    navigate(AppRoutes.root);
                                })
                        }
                    }).finally(() => {
                        setloading(false);
                    });
                }
                setloading(false);
            })
    };
    const validationSchema = Yup.object().shape({
          selectedLOB: Yup.string().nullable().required('Line of Business is required'),
          insuranceId: Yup.string().required('Carrier is required'),
          });

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <React.Fragment>
                <Formik
                    enableReinitialize={true}
                    initialValues={{
                        ...CustomerPolicyDetails,
                        naic: CustomerPolicyDetails?.nAIC || '',
                        selectedLOB: selectedLOB ?? '',
                        insuranceId: insuranceId
                     }}
                    validationSchema={validationSchema} 
                    onSubmit={(data, { setSubmitting }) => {
                        setloading(true);
                        data.customerPolicyId = Number(params.CustomerPolicyId);
                        data.insuranceCompanyId = Number(insuranceId);
                        data.stateId = selectedStateOption;
                        data.transactionId = Number(selectedTransaction);
                        data.lobId = Number(selectedLOB);
                        data.partnersId = Number(partnerId);

                        data.status = getPolicyStatus;
                        if ((revertDocument ?? []).length > 0) {
                            data.status = 'Waiting on Client';
                        }
                        CustTaxAndFees.forEach((element, index) => {
                            element.payee = (document?.getElementById("payee" + index) as HTMLInputElement)?.value ?? ""
                            element.amount = (document?.getElementById("amount" + index) as HTMLInputElement)?.value ?? ""
                        });
                        data.customerPolicyTaxAnFee = CustTaxAndFees;
                        formData.append("data", JSON.stringify(data)); // Add the main data object
                        const revertPayload = (revertDocument ?? []).map(x => ({
                            documentTypeId: x.documentTypeId,
                            customerPolicyDocumentId: x.customerPolicyDocumentId,
                            isRevert: 1
                        }));
                        formData.append("revertDocument", JSON.stringify(revertPayload));
                        apiClient(`/CustomerPolicy/UpdateCustomerPolicyDetails`,
                            {
                                method: 'POST',
                                headers: new Headers({
                                    'Authorization': `Bearer ${token}`,
                                }),
                                body: formData

                            })
                            .then((res) => {
                                if (res.resp == 0) {
                                    Swal.fire({
                                        title: "Data Successfully Updated",
                                        text: "success",
                                        icon: "success",
                                        confirmButtonColor: '#02A4E3',
                                        confirmButtonText: 'Ok',
                                        customClass: {
                                            popup: 'custom-success-popup',
                                            title: 'custom-success-title',
                                            htmlContainer: 'custom-success-content',
                                            confirmButton: 'custom-success-button'
                                        },
                                        showConfirmButton: true,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            if ((revertDocument ?? []).length > 0) {
                                                try {
                                                    apiClient(`/PolicyDashBoard/updateCustomerPolicyStatus`, {
                                                        method: 'POST',
                                                        headers: new Headers({
                                                            'Content-Type': 'application/json',
                                                            'Authorization': `Bearer ${token}`,
                                                        }),
                                                        body: JSON.stringify({
                                                            customerPolicyId: Number(params.CustomerPolicyId),
                                                            status: 'Waiting on Client'
                                                        })
                                                    })
                                                } catch {}
                                            }
                                            navigate(-1);
                                        }
                                    });
                                }
                            }).finally(() => {
                                setSubmitting(false);
                                setloading(false);
                            });

                    }} >
                    {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) =>
                    (
                        <Form>
                            {loading && <LinearProgress style={{ margin: 2 }} />}
                            <div className=" col-lg-12 main-form">

                                <Grid xs={12} container spacing={2} >

                                    <Grid item xs={12} >
                                        <Grid item xs={12} display='flex' flexDirection='row'>
                                            <span className="card-title mb-4" >Update Transaction Data</span>
                                        </Grid>
                                        <Grid item xs={12}  >
                                            <Grid item xs={12} sx={{ display: "flex" }}>

                                                <Grid item xs={6}>
                                                    <FormControl sx={{ width: '100%' }} className="main-form-2  field-text" >
                                                        <InputLabel id="State-Select-Label" className="border-round ">Select State</InputLabel>
                                                        <Select
                                                            labelId="State-Select-Label"
                                                            onChange={handleStateOptionChange}
                                                            label={"Select State"}
                                                            value={selectedStateOption}
                                                            disabled={!isAdmin}
                                                            IconComponent={ExpandMoreIcon}

                                                        >
                                                            {States?.map((val, key) =>
                                                                <MenuItem key={key} value={val.stateId}> {val.stateName} </MenuItem>
                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={.3}></Grid>
                                                <Grid item xs={6}>
                                                    <FormControl 
                                                        sx={{ width: '100%' }}
                                                        className="main-form-2  field-text"
                                                        error={touched.insuranceId && Boolean(errors.insuranceId)}
                                                    >
                                                        <InputLabel id="demo-simple-select-carrier" className="border-round">Select Carrier</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-carrier"
                                                            id="selectedLOB"
                                                            onChange={handleInsuranceChange}
                                                            label={"Select Carrier"}
                                                            value={insuranceId}
                                                            IconComponent={ExpandMoreIcon}
                                                            disabled={!isAdmin}
                                                            name="selectedLOB"
                                                            onBlur={handleBlur}
                                                        >
                                                            {carriers?.map((val, key) =>
                                                                <MenuItem key={key} value={val.insuranceCompanyId}> {val.insuranceCompanyName} </MenuItem>
                                                            )}
                                                        </Select>
                                                        {touched.insuranceId && errors.insuranceId && (
                                                            <FormHelperText>{errors.insuranceId}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={.3}>

                                                </Grid>
                                                <Grid item xs={6}>
                                                    <FormControl sx={{ width: '100%' }} className="main-form-2  field-text" >
                                                        <InputLabel id="demo-simple-select-partner" className="border-round">Select Client</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-partner"
                                                            onChange={handlePatnerChange}
                                                            label={"Select Client"}
                                                            disabled={!isAdmin}
                                                            value={partnerId}
                                                            IconComponent={ExpandMoreIcon}
                                                        >
                                                            {getPartners?.map((val, key) =>
                                                                <MenuItem key={key} value={val.partnersId}> {val.customerName} </MenuItem>
                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={.3}>

                                                </Grid>

                                                <Grid item xs={6}>
                                                    <FormControl sx={{ width: '100%' }} className="main-form-2  field-text" >
                                                        <InputLabel id="demo-simple-select-tran" className="border-round">Select Transaction</InputLabel>
                                                        <Select
                                                            labelId="demo-simple-select-tran"
                                                            onChange={handleTransactionChange}
                                                            label={"Select Transaction"}
                                                            disabled={!isAdmin}
                                                            value={selectedTransaction}
                                                            IconComponent={ExpandMoreIcon}
                                                        >
                                                            {TransactionType?.map((val, key) =>
                                                                <MenuItem key={key} value={val.transactionId}> {val.transactionTypeName} </MenuItem>
                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={.3}>
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <FormControl 
                                                        sx={{ width: '100%' }}
                                                        className="main-form-2  field-text"
                                                        error={touched.selectedLOB && Boolean(errors.selectedLOB)}
                                                    >
                                                        <InputLabel id="demo-simple-select-lob" className="border-round">Select line of business</InputLabel>
                                                        <Select
                                                            labelId="lob-label"
                                                            id="selectedLOB"
                                                            name="selectedLOB"
                                                            onChange={handleLOBChange}
                                                            label={"Select line of business"}
                                                            disabled={!isAdmin}
                                                            value={selectedLOB ?? ''}
                                                            IconComponent={ExpandMoreIcon}
                                                            onBlur={handleBlur}
                                                        >
                                                            {LOB?.map((val, key) =>
                                                                <MenuItem key={key} value={val.id}> {val.businessCode} </MenuItem>
                                                            )}
                                                        </Select>
                                                        {touched.selectedLOB && errors.selectedLOB && (
                                                            <FormHelperText>{errors.selectedLOB}</FormHelperText>
                                                        )}
                                                    </FormControl>
                                                </Grid>
                                                <Grid item xs={.3}></Grid>

                                            </Grid>
                                        </Grid>
                                    </Grid>


                                    <Grid item xs={12} display='flex' flexDirection='row'>
                                        <span className="sub-card-title " >Policy</span>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl
                                            disabled={!isAdmin}
                                            sx={{ width: '100%' }} >
                                            <FormHelperText
                                                className='formtexthelper-heading' >
                                                Invoice Number
                                            </FormHelperText>
                                            <FMTextField name="invoiceNumber"
                                                disabled={!isAdmin}
                                                InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={{}} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Policy Number
                                            </FormHelperText>
                                            <FMTextField
                                                name="policyNumber"
                                                disabled={isPolicyNumberDisabled}
                                                InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={{}} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormHelperText className='formtexthelper-heading' >Policy Effective Date</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            disabled={!isAdmin}
                                            className="select-input-border text-input-box"
                                            value={values.policyEffDate ?? ""}
                                            onChange={(v) =>
                                                setFieldValue("policyEffDate", v)
                                            }
                                            // value={EffectiveDate}
                                            // onChange={(v) => effectiveDateStartChnage(v ?? "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    id="effectiveDateStart"
                                                    name="policyEffDate" />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormHelperText className='formtexthelper-heading' >Expiration Date</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            className="select-input-border text-input-box"
                                            disabled={!isAdmin}
                                            value={values.policyExpDate ?? ""}
                                            onChange={(v) =>
                                                setFieldValue("policyExpDate", v)
                                            }
                                            // value={ExpDate}
                                            // onChange={(v) => expDataHandleChange(v ?? "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    name="policyExpDate" />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormHelperText className='formtexthelper-heading' >Invoice Date</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            className="select-input-border text-input-box"
                                            //value={InvoiceDate}
                                            disabled={!isAdmin}
                                            value={values.invDate ?? ""}
                                            onChange={(v) =>
                                                setFieldValue("invDate", v)
                                            }
                                            // onChange={(v) => InvoiceDateHandleChange(v ?? "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    name="invDate" />
                                            )}
                                        />
                                    </Grid>



                                    {/* <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormHelperText className='formtexthelper-heading' >Date Filed</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            className="select-input-border text-input-box"
                                            value={DateFiled}
                                            disabled={!isAdmin}
                                            onChange={(v) => dateFiledHandleChange(v ?? "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    name="dateFiled" />
                                            )}
                                        />
                                    </Grid> */}

                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                NAIC
                                            </FormHelperText>
                                            <FMTextField
                                                name="naic"
                                                disabled={!isAdmin}
                                                InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={{}} />

                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Filing Due Date
                                            </FormHelperText>
                                            <FMTextField name="policyFilingDueDate" disabled InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={{}} />

                                        </FormControl>
                                        {/* <FormHelperText className='formtexthelper-heading' >Filing Due Date</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            className="select-input-border text-input-box"
                                            value={FilingDueDate}
                                            onChange={(v) => handleChangeFilingDueDate(v ?? "")}
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    name="policyFilingDueDate" />
                                            )}
                                        /> */}
                                    </Grid>
                                    { (selectedTransaction == '29' || selectedTransaction == '8' || selectedTransaction == '9' || selectedTransaction == '10') && (
                                        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                            <FormControl sx={{ width: '100%' }} >
                                                <FormHelperText className='formtexthelper-heading' >
                                                    Parent Policy {values.parentPolicyId ? <Link href={`/Admin/AddEditCustomerPolicyDetails/${values.parentPolicyId}`}>Link</Link> : 'Link'}
                                                </FormHelperText>
                                                <FMTextField name="parentPolicyNumber" disabled InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={{}} />
                                            </FormControl>
                                        </Grid>
                                    )}
                                    <Grid item xs={12} display='flex' flexDirection='row'>
                                        <span className="sub-card-title " >Insured</span>
                                    </Grid>

                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Insured Name
                                            </FormHelperText>
                                            <FMTextField
                                                name="insuredName"
                                                disabled={!isAdmin}
                                                InputLabelProps={{ shrink: true }} label={null} type="text" fullWidth variant="outlined" sx={{}} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} display='flex' flexDirection='row'>
                                        <span className="sub-card-title " >Premium & Taxes</span>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Premium
                                            </FormHelperText>
                                            <FMTextField
                                                label={null}
                                                type="text"
                                                name="grossPremium"
                                                id="formatted-numberformat-input"
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom as any,
                                                }}
                                                fullWidth variant="outlined"
                                                sx={{}}
                                            />

                                            {/* <FMTextField
                                                name="grossPremium"
                                                InputLabelProps={{ shrink: true }}
                                                label={null}
                                                type="text"
                                                fullWidth variant="outlined"
                                                sx={{}}

                                            /> */}

                                        </FormControl>
                                    </Grid>

                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Non Admitted Premium
                                            </FormHelperText>
                                            {/* <FMTextField
                                                name="nonAdmittedPremium"
                                                InputLabelProps={{ shrink: true, }}
                                                label={null} type="Text"
                                                fullWidth variant="outlined"
                                            
                                            /> */}
                                            <FMTextField
                                                label={null}
                                                // value={values.nonAdmittedPremium}
                                                type="text"
                                                // onChange={handleChange}
                                                name="nonAdmittedPremium"
                                                id="formatted-numberformat-input"
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom as any,
                                                }}
                                                fullWidth variant="outlined"
                                                sx={{}}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Fee
                                            </FormHelperText>
                                            {/* <FMTextField
                                                name="fee"
                                                InputLabelProps={{ shrink: true }}
                                                label={null}
                                                type="Text"
                                                fullWidth variant="outlined"
                                                sx={{}}
                                            
                                            /> */}
                                            <FMTextField
                                                label={null}
                                                value={values.fee}
                                                type="text"
                                                // onChange={handleChange}
                                                name="fee"
                                                id="formatted-numberformat-input"
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom as any,
                                                }}
                                                fullWidth variant="outlined"
                                                sx={{}}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Stamping Fee
                                            </FormHelperText>
                                            <FMTextField
                                                label={null}
                                                // value={values.stampingFee}
                                                type="text"
                                                // onChange={handleChange}
                                                name="stampingFee"
                                                id="formatted-numberformat-input"
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom as any,
                                                }}
                                                fullWidth variant="outlined"
                                                sx={{}}
                                            />
                                            {/* <FMTextField
                                                name="stampingFee"
                                                InputLabelProps={{ shrink: true }}
                                                label={null} type="Text"
                                                fullWidth variant="outlined"
                                                sx={{}}
                                            
                                            /> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                State Tax
                                            </FormHelperText>
                                            <FMTextField
                                                label={null}
                                                // value={values.stateTax}
                                                type="text"
                                                // onChange={handleChange}
                                                name="stateTax"
                                                id="formatted-numberformat-input"
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom as any,
                                                }}
                                                fullWidth variant="outlined"
                                                sx={{}}
                                            />
                                            {/* <FMTextField
                                                name="stateTax"
                                                InputLabelProps={{ shrink: true }}
                                                label={null}
                                                type="Text"
                                                fullWidth variant="outlined"
                                            
                                            /> */}
                                        </FormControl>
                                    </Grid>

                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Tax Balance
                                            </FormHelperText>
                                            <FMTextField
                                                label={null}
                                                // value={values.taxBalance}
                                                type="text"
                                                // onChange={handleChange}
                                                name="taxBalance"
                                                id="formatted-numberformat-input"
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom as any,
                                                }}
                                                fullWidth variant="outlined"
                                                sx={{}}
                                            />
                                            {/* <FMTextField
                                                name="taxBalance"
                                                InputLabelProps={{ shrink: true }}
                                                label={null}
                                                type="Text"
                                                fullWidth variant="outlined"
                                            /> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Taxable Fees
                                            </FormHelperText>
                                            <FMTextField
                                                label={null}
                                                // value={values.taxableFees}
                                                type="text"
                                                // onChange={handleChange}
                                                name="taxableFees"
                                                id="formatted-numberformat-input"
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom as any,
                                                }}
                                                fullWidth variant="outlined"
                                                sx={{}}
                                            />
                                            {/* <FMTextField
                                                name="taxableFees"
                                                InputLabelProps={{ shrink: true }}
                                                label={null}
                                                type="Text"
                                                fullWidth variant="outlined"
                                            
                                            /> */}
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Non Taxable Fees
                                            </FormHelperText>
                                            <FMTextField
                                                label={null}
                                                // value={values.nonTaxableFees}
                                                type="text"
                                                // onChange={handleChange}
                                                name="nonTaxableFees"
                                                id="formatted-numberformat-input"
                                                InputProps={{
                                                    inputComponent: NumericFormatCustom as any,
                                                }}
                                                fullWidth variant="outlined"
                                                sx={{}}
                                            />
                                            {/* <FMTextField
                                                name="nonTaxableFees"
                                                InputLabelProps={{ shrink: true }}
                                                label={null}
                                                type="Text"
                                                fullWidth variant="outlined"
                                                 InputProps={{
                                                    inputComponent: NumericFormatCustom as any,
                                                }}
                                            /> */}
                                        </FormControl>
                                    </Grid>

                                    {/* <Grid item xs={12} display='flex' flexDirection='row'>
                                        <span className="sub-card-title" >Tax Type</span>
                                        {CustTaxAndFees?.length >= taxAndFeeOptions?.length ? "" :
                                            <button
                                                className="btn active-btn-blue"
                                                type="button"
                                                style={{ marginLeft: '50px', marginTop: '15px' }}
                                                onClick={() => {
                                                    // if (CustTaxAndFees.length >= taxAndFeeOptions.length) return
                                                    setCustTaxAndFees(filingContactArry => [...filingContactArry, initTaxAndFee])
                                                }}
                                                disabled={!isAdmin}
                                            >
                                                Add More
                                            </button>
                                        }

                                    </Grid> */}
                                    <Grid item xs={12} display='flex' flexDirection='row'>
                                        <span className="sub-card-title">Tax Type</span>
                                        {
                                            (isAdmin || mISCFiler || MISCStateReporter) ? (
                                                <button
                                                    className="btn active-btn-blue"
                                                    type="button"
                                                    style={{ marginLeft: '50px', marginTop: '15px' }}
                                                    onClick={() => {
                                                        setCustTaxAndFees(filingContactArry => [...filingContactArry, initTaxAndFee])
                                                    }}
                                                    disabled={false} // Button will be enabled if the user is an admin or has the specified roles
                                                >
                                                    Add More
                                                </button>
                                            ) : null
                                        }
                                    </Grid>

                                    {(CustTaxAndFees ?? []).map((taxAndFee, index) => (
                                        <React.Fragment key={index}>

                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                <FormHelperText className='formtexthelper-heading' >
                                                    Tax Type
                                                </FormHelperText>
                                                <FormControl sx={{ width: '100%' }} >
                                                    {/* <FMSelectTaxAndFeesustom autoWidth={true} name="taxName" key={"taxName" + index} defaultValue={taxAndFee.taxName}></FMSelectTaxAndFeesustom> */}
                                                    <Select
                                                        value={taxAndFee.taxName}
                                                        id="test-select-label"
                                                        label={null}
                                                        onChange={(e) => handleTaxNameChange(e, index)}
                                                        // disabled={!isFileMuleUser}
                                                         disabled={
                                                            !(
                                                                user?.userRoles.split(",").includes("Super Admin") ||
                                                                user?.userRoles.split(",").includes("MISC Filer") ||
                                                                user?.userRoles.split(",").includes("MISC State Reporter")
                                                            )
                                                        }
                                                        name="TaxAndFee"
                                                        className="border-round custom-menu-item"
                                                        IconComponent={ExpandMoreIcon}
                                                        displayEmpty
                                                    >
                                                        {(taxAndFeeOptions ?? []).map((fee, key) => (
                                                            <MenuItem key={key} value={fee}  >
                                                                {fee}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                <FormHelperText className='formtexthelper-heading' >
                                                    Tax Payee
                                                </FormHelperText>
                                                <FormControl sx={{ width: '100%' }} >
                                                    <TextField name={"payee" + index}
                                                        // disabled={!(user?.userRoles.split(",").includes("Super Admin"))}
                                                        disabled={
                                                            !(
                                                                user?.userRoles.split(",").includes("Super Admin") ||
                                                                user?.userRoles.split(",").includes("MISC Filer") ||
                                                                user?.userRoles.split(",").includes("MISC State Reporter")
                                                            )
                                                        }
                                                        key={"payee" + index}
                                                        id={"payee" + index}
                                                        defaultValue={taxAndFee.payee} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                <FormHelperText className='formtexthelper-heading' >
                                                    Amount
                                                </FormHelperText>
                                                <FormControl sx={{ width: '100%' }} >
                                                    <TextField
                                                        name={"amount" + index}
                                                        id={"amount" + index}
                                                        key={"amount" + index}
                                                        defaultValue={taxAndFee.amount}
                                                        InputProps={{
                                                            inputComponent: NumericFormatCustom as any,
                                                        }}

                                                    />
                                                </FormControl>
                                            </Grid>

                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>

                                            </Grid>

                                        </React.Fragment>
                                    ))}



                                    <Grid item xs={12} display='flex' flexDirection='row'>
                                        <span className="sub-card-title" >Notes</span>
                                    </Grid>


                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Client Notes
                                            </FormHelperText>
                                            <FMTextField name="clientNotes"
                                                InputLabelProps={{ shrink: true }}
                                                label={null} type="Text"
                                                fullWidth variant="outlined" sx={{}} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Client div
                                            </FormHelperText>
                                            <FMTextField name="clientDiv" InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={{}} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} display='flex' flexDirection='row'>
                                        <span className="sub-card-title" >Status</span>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Filer Notes
                                            </FormHelperText>
                                            <FMTextField name="filerNotes"
                                                InputLabelProps={{ shrink: true }}
                                                label={null} type="Text"
                                                fullWidth variant="outlined" sx={{}} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormControl sx={{ width: '100%' }} >
                                            <FormHelperText className='formtexthelper-heading' >
                                                Filer Name
                                            </FormHelperText>
                                            <FMTextField name="filerName" InputLabelProps={{ shrink: true }} label={null} type="Text" fullWidth variant="outlined" sx={{}} />
                                        </FormControl>
                                    </Grid>
                                    <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                        <FormHelperText className='formtexthelper-heading' >Date Filed</FormHelperText>
                                        <DatePicker
                                            inputFormat="MM/DD/YYYY"
                                            label={null}
                                            className="select-input-border text-input-box"
                                            // value={DateFiled}
                                            // onChange={(v) => dateFiledHandleChange(v ?? "")}
                                            value={values.dateFiled ?? ""}
                                            onChange={(v) =>
                                                setFieldValue("dateFiled", v)
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                    name="dateFiled" />
                                            )}
                                        />
                                    </Grid>
                                    {/* {CustomerPolicyDetails.policySubStatus === 'Filed on Binder' ? */}
                                    {/* {binderFiledDate !== '' && binderFiledDate !== undefined && binderFiledDate !== null  ? */}
                                    {isValid(binderFiledDate)  ?
                                        <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                            <FormHelperText className='formtexthelper-heading'>Filed with Binder Date</FormHelperText>
                                            <DatePicker
                                                inputFormat="MM/DD/YYYY"
                                                label={null}
                                                className="select-input-border text-input-box"
                                                value={values.filedBinderDate ?? ""}
                                                onChange={(v) =>
                                                    setFieldValue("filedBinderDate", v)
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        {...params}
                                                        name={"filedBinderDate"} />
                                                )}
                                            />
                                        </Grid>
                                        : ""}
                                    <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                <FormHelperText className='formtexthelper-heading' >First Request</FormHelperText>
                                                <DatePicker
                                                    inputFormat="MM/DD/YYYY"
                                                    label={null}
                                                    // disabled={!isAdmin}
                                                    className="select-input-border text-input-box"
                                                    shouldDisableDate={isDateGreaterThanToday}
                                                    value={values.firstRequest ?? ""}
                                                    onChange={(v) =>
                                                        setFieldValue("firstRequest", v)
                                                    }
                                                    // value={FirstRequest}
                                                    // onChange={(v) => firstRquestHandleChange(v ?? "")}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            {...params}
                                                            name="firstRequest" />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                <FormHelperText className='formtexthelper-heading' >Second Request</FormHelperText>
                                                <DatePicker
                                                    inputFormat="MM/DD/YYYY"
                                                    label={null}
                                                    //disabled={!isAdmin}
                                                    className="select-input-border text-input-box"
                                                    shouldDisableDate={isDateGreaterThanToday}
                                                    value={values.secondRequest ?? ""}
                                                    onChange={(v) =>
                                                        setFieldValue("secondRequest", v)
                                                    }
                                                    // value={SecondRequest}
                                                    // onChange={(v) => secondRquestHandleChange(v ?? "")}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            {...params}
                                                            name="secondRequest" />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                <FormHelperText className='formtexthelper-heading' >Third & Final Request</FormHelperText>
                                                <DatePicker
                                                    inputFormat="MM/DD/YYYY"
                                                    label={null}
                                                    //disabled={!isAdmin}
                                                    className="select-input-border text-input-box"
                                                    shouldDisableDate={isDateGreaterThanToday}
                                                    value={values.thirdRequest ?? ""}
                                                    onChange={(v) =>
                                                        setFieldValue("thirdRequest", v)
                                                    }
                                                    // value={ThirdRequest}
                                                    // onChange={(v) => thirdRquestHandleChange(v ?? "")}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            {...params}
                                                            name="thirdRequest" />
                                                    )}
                                                />
                                            </Grid>
                                            <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
                                                <FormHelperText className='formtexthelper-heading' >Suspended</FormHelperText>
                                                <DatePicker
                                                    inputFormat="MM/DD/YYYY"
                                                    label={null}
                                                    //disabled={!isAdmin}
                                                    className="select-input-border text-input-box"
                                                    shouldDisableDate={isDateGreaterThanToday}
                                                    value={values.suspended ?? ""}
                                                    onChange={(v) =>
                                                        setFieldValue("suspended", v)
                                                    }
                                                    // value={Susupended}
                                                    // onChange={(v) => suspendedHandleChange(v ?? "")}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            fullWidth
                                                            size="small"
                                                            {...params}
                                                            name="suspended" />
                                                    )}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} display='flex' flexDirection='row'>
                                        <span className="sub-card-title " >Transaction Documents </span>
                                    </Grid>
                                    {RequireedDocuments && RequireedDocuments.length > 0 ?
                                        <DialogContent>
                                            {/* <div className="card-body">
                                                <div className="document-container">
                                                    {
                                                        RequireedDocuments?.map((file, key) => (
                                                            <div key={key} className="document-item" style={{backgroundColor: "white"}}>
                                                                {UploadedDocument.find((item) => item.documentTypeId == file.documentTypeId) ? 
                                                                    <ViewDocuments docTypeId={file.documentTypeId}/>
                                                                    :
                                                                    <GenericStyledDropZone
                                                                        key={key} doc={file}
                                                                        limitSize={CustomerPolicyDetails?.homeState === 'NY' ? 1 : 10}
                                                                    />
                                                                }
                                                            </div>
                                                        ))
                                                    }
                                                </div>
                                            </div> */}
                                            <div className="card-body">
                                {loading && <LinearProgress sx={{ backgroundColor: "#132D3D" }} />}
                                <Box sx={{ width: '100%', mb: 2 }}>
                                    <DataGridPro
                                        key={`datagrid-${refreshKey}-${groupedRows.length}`}
                                        autoHeight
                                        rows={groupedRows.map((r, idx) => ({
                                            id: `${r.first.customerPolicyDocumentId}-${idx}`,
                                            fileName: r.fileName,
                                            docTypeNames: r.docTypeNames,
                                            uploadedAt: r.uploadedAt,
                                            uploadedBy: r.uploadedBy,
                                            sizeText: r.sizeText,
                                            pagesText: r.pagesText,
                                            first: r.first,
                                            allDocuments: r.allDocuments
                                        }))}
                                        columns={([
                                            { field: 'fileName', headerName: 'File Name', flex: 1, minWidth: 200, renderCell: (params) => (
                                                <Link href={params.row.first.blob_Address} target="_blank" sx={{ textDecoration: 'none', overflow: 'initial', textOverflow: 'ellipsis', whiteSpace: 'break-spaces',lineHeight:'normal' }}>{params.value || '-'}</Link>
                                            ) },
                                            { field: 'docTypeNames', headerName: 'Document Types', flex: 1, minWidth: 310, maxWidth: 400, renderCell: (params) => (
                                                    <Box sx={{ width: '100%', overflow: 'initial', textOverflow: 'ellipsis', whiteSpace: 'break-spaces',lineHeight:'normal' }}>{params.value || '-'}</Box>
                                            ) },
                                            { field: 'uploadedAt', headerName: 'Upload Date', flex: 0.8, minWidth: 160 },
                                            { field: 'uploadedBy', headerName: 'Uploaded By', flex: 0.8, minWidth: 160 },
                                            { field: 'sizeText', headerName: 'File Size', flex: 0.6, minWidth: 120 },
                                            // { field: 'pagesText', headerName: 'Pages', flex: 0.4, minWidth: 100 },
                                              ( canDeleteDocuments() && {field: 'actions', 
                                                headerName: 'Actions', 
                                                sortable: false, 
                                                filterable: false, 
                                                flex: 0.5, 
                                                minWidth: 120, 
                                                renderCell: (params: any) => (
                                                    <IconButton color="error" onClick={() => handleRemoveUploadedDoc(params.row)}>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6" stroke="#162E3C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                    </IconButton>
                                                )})
                                        ]) as GridColDef[]}
                                        pagination
                                        rowsPerPageOptions={[5, 10, 25]}
                                        // pageSize={rowsPerPage}
                                        // onPageSizeChange={(newPageSize: number) => setRowsPerPage(newPageSize)}
                                        // onPageChange={(newPage: number) => setPage(newPage)}
                                        disableSelectionOnClick
                                        disableColumnMenu
                                        sx={{
                                            borderRadius: '10px',
                                            overflow: 'hidden',
                                            fontFamily: "'Proxima Nova', sans-serif",
                                            fontSize: '14px',
                                            '& .MuiDataGrid-main': {
                                                overflow: 'hidden'
                                            }
                                        }}
                                    />
                                </Box>
                            </div>
                                            {AppFlags  && data?.isClient ? 
                                                <Grid item xs={12} display="flex" justifyContent="flex-end" alignItems="center" mt={2}>
                                                    <Box display="flex" alignItems="center" ml="auto">
                                                        <button
                                                            type="button"
                                                            className="active-btn-blue"
                                                            onClick={() =>
                                                                handleSendMessage(Number(params.CustomerPolicyId), getPolicyStatus || "")
                                                            }
                                                            >
                                                            Message
                                                        </button>
                                                    </Box>
                                                </Grid>
                                            : null}
                                        </DialogContent>
                                        :
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <DialogTitle className="col-log-2">No mapping present for this transaction, you can upload supportive document here.</DialogTitle>
                                            </Grid>
                                        </Grid>
                                    }
                                    <Grid item xs={12} className="d-flex">
                                        <div className="d-flex">
                                            <div style={{ display: "flex", marginBottom: "20px" }}>
                                                {user?.userRoles.split(",").includes("Super Admin") ||
                                                    user?.userRoles.split(",").includes("MISC Filer") ||
                                                    user?.userRoles.split(",").includes("MISC State Reporter")
                                                    ?
                                                    <button className="active-btn-blue me-2" type='submit' disabled={isSubmitting} >Save</button>
                                                    :
                                                    <button className="active-btn-blue me-2" disabled >Save</button>
                                                }
                                            </div>
                                            <div style={{ display: "flex", marginBottom: "20px" }}>
                                                {user?.userRoles.split(",").includes("Super Admin") ?
                                                    <button className="active-btn-blue" type="button" onClick={handlDeletePolicy}>Remove Policy</button>
                                                    : ""
                                                }
                                                {loading && <CircularProgress style={{ margin: 2 }} />}
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>
                        </Form>
                    )}
                </Formik>
                <ShowAllDocument open={showDoc} PolicyDocument={PolicyDocument} handleDocClose={handleDocClose} customerPolicyId={CustomerPolicyDetails.customerPolicyId}></ShowAllDocument>
            </React.Fragment>
        </LocalizationProvider >
    )
}